import { useRegisterSW } from 'virtual:pwa-register/react';
import { buttonClass } from '@/ui/button';
import styles from './UpdatePrompt.module.css';

/**
 * Offline support and updates (F10.5). The service worker caches the app; when a new version is
 * ready the user chooses when to switch, because reloading clears this tab's songs.
 */
export function UpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    offlineReady: [offlineReady, setOfflineReady],
    updateServiceWorker,
  } = useRegisterSW();

  if (!needRefresh && !offlineReady) return null;
  const dismiss = () => {
    setNeedRefresh(false);
    setOfflineReady(false);
  };

  return (
    <div role="status" className={styles.toast}>
      <span>
        {needRefresh
          ? 'A new version of KnowYourChord is ready.'
          : 'KnowYourChord now works offline.'}
      </span>
      {needRefresh && (
        <button
          type="button"
          className={buttonClass('primary')}
          onClick={() => void updateServiceWorker(true)}
        >
          Update
        </button>
      )}
      <button type="button" className={buttonClass('ghost')} onClick={dismiss}>
        {needRefresh ? 'Later' : 'OK'}
      </button>
    </div>
  );
}
